module.exports = __webpack_public_path__ + "img/sana-metropolitan-hotel.d1ab88bb.jpg";